import { NavLink, useLocation } from 'react-router-dom'
import {
  LayoutGrid, ClipboardList, User,
  Wrench, Wallet, Home,
  BarChart2, Users, FileText, Settings,
} from 'lucide-react'
import { useAuth } from '@/hooks/useAuth'
import { ROUTES } from '@/config/routes'

// ─── Tab Definitions per Role ─────────────────────────────────────────────────
const CUSTOMER_TABS = [
  { to: ROUTES.BOOK,         label: 'Book',    Icon: LayoutGrid  },
  { to: ROUTES.BOOK_HISTORY, label: 'Jobs',    Icon: ClipboardList },
  { to: '/profile',          label: 'Profile', Icon: User        },
]

const WORKER_TABS = [
  { to: ROUTES.WORKER_HOME,    label: 'Jobs',     Icon: Wrench    },
  { to: ROUTES.WORKER_EARNINGS,label: 'Earnings', Icon: Wallet    },
  { to: '/profile',            label: 'Profile',  Icon: User      },
]

const ADMIN_TABS = [
  { to: ROUTES.ADMIN,            label: 'Overview', Icon: BarChart2   },
  { to: ROUTES.ADMIN_QUOTES,     label: 'Quotes',   Icon: FileText    },
  { to: ROUTES.ADMIN_WORKERS,    label: 'Workers',  Icon: Users       },
  { to: ROUTES.ADMIN_FINANCIALS, label: 'Finance',  Icon: Wallet      },
  { to: ROUTES.ADMIN_RATES,      label: 'Rates',    Icon: Settings    },
]

export default function MobileNav() {
  const { isAdmin, isWorker } = useAuth()
  const location = useLocation()

  // Hide nav on auth pages
  const hiddenPaths = ['/login', '/auth/callback', '/setup-profile']
  if (hiddenPaths.some((p) => location.pathname.startsWith(p))) return null

  const tabs = isAdmin ? ADMIN_TABS : isWorker ? WORKER_TABS : CUSTOMER_TABS

  return (
    <nav className="
      fixed bottom-0 left-0 right-0 z-40
      bg-surface-raised/95 backdrop-blur-md
      border-t border-surface-border
      safe-bottom
    ">
      <div className="flex items-stretch justify-around px-2">
        {tabs.map(({ to, label, Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === ROUTES.BOOK || to === ROUTES.ADMIN || to === ROUTES.WORKER_HOME}
            className={({ isActive }) => `
              flex flex-col items-center justify-center gap-1 py-2.5 px-3
              min-w-0 flex-1 text-center
              transition-colors duration-150
              ${isActive
                ? 'text-siglat-teal'
                : 'text-ink-muted hover:text-ink-secondary'}
            `}
          >
            {({ isActive }) => (
              <>
                <span className="relative">
                  <Icon className={`w-5 h-5 ${isActive ? 'stroke-[2.2]' : 'stroke-[1.7]'}`} />
                  {/* Active indicator dot */}
                  {isActive && (
                    <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-siglat-teal" />
                  )}
                </span>
                <span className={`text-[10px] font-medium truncate ${isActive ? 'font-semibold' : ''}`}>
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
